import m from "../../es2015/themes/dataviz";
window.am4themes_dataviz = m;


//////////////////
// WEBPACK FOOTER
// ./themes/dataviz.js
// module id = null
// module chunks = 